import './AISecMarkets.css'

const AISecMarkets = () => {
  return (
    <div className="aisec-markets-page">
      <div className="page-header">
        <div>
          <h2>🌍 AI Security Training Market — Spending Power & Buyer Type (Global)</h2>
          <p className="subtitle">Market intelligence to inform sales strategy and targeting</p>
        </div>
      </div>

      <div className="markets-container">
        {/* Global Market Table */}
        <section className="market-section">
          <h3>Global Market Table</h3>
          <div className="table-container">
            <table className="markets-table">
              <thead>
                <tr>
                  <th>Region / Country</th>
                  <th>Spending Power</th>
                  <th>Primary Buyer Type</th>
                  <th>Likely License</th>
                  <th>Typical Buyer Roles</th>
                  <th>Key Buying Drivers</th>
                  <th>Price Sensitivity</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>🇺🇸 United States</td>
                  <td>⭐⭐⭐⭐⭐ Very High</td>
                  <td>Enterprise-first</td>
                  <td>Team / Enterprise</td>
                  <td>CISO, Head of Security, AI Risk Lead, Compliance</td>
                  <td>Legal liability, AI risk, board pressure, scale</td>
                  <td>Low</td>
                </tr>
                <tr>
                  <td>🇬🇧 United Kingdom</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Enterprise-first</td>
                  <td>Team</td>
                  <td>Risk, Compliance, Security Architecture</td>
                  <td>AI Act prep, GDPR, ISO, governance</td>
                  <td>Medium</td>
                </tr>
                <tr>
                  <td>🇩🇪 Germany</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Enterprise-first</td>
                  <td>Team / Enterprise</td>
                  <td>Compliance, IT Security, Works Councils</td>
                  <td>Regulation, operational risk</td>
                  <td>Medium</td>
                </tr>
                <tr>
                  <td>🇫🇷 France</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Enterprise-first</td>
                  <td>Team</td>
                  <td>Security, Legal, AI Governance</td>
                  <td>Sovereignty, regulation</td>
                  <td>Medium</td>
                </tr>
                <tr>
                  <td>🇳🇱 Netherlands</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Enterprise-first</td>
                  <td>Team</td>
                  <td>CISO, Cloud Security</td>
                  <td>Cloud risk, EU compliance</td>
                  <td>Medium</td>
                </tr>
                <tr>
                  <td>🇸🇪 Sweden</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Enterprise-first</td>
                  <td>Team</td>
                  <td>Security Leaders, Product Security</td>
                  <td>AI ethics, secure innovation</td>
                  <td>Medium</td>
                </tr>
                <tr>
                  <td>🇨🇭 Switzerland</td>
                  <td>⭐⭐⭐⭐⭐ Very High</td>
                  <td>Enterprise-first</td>
                  <td>Enterprise</td>
                  <td>Risk, Banking Security, GRC</td>
                  <td>Financial risk, trust</td>
                  <td>Low</td>
                </tr>
                <tr>
                  <td>🇸🇬 Singapore</td>
                  <td>⭐⭐⭐⭐⭐ Very High</td>
                  <td>Enterprise & Individual</td>
                  <td>Team / Premium Individual</td>
                  <td>GovTech, Finance, Security Leads</td>
                  <td>AI governance leadership</td>
                  <td>Low</td>
                </tr>
                <tr>
                  <td>🇦🇪 UAE</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Government-led</td>
                  <td>Enterprise</td>
                  <td>Gov AI, National Security</td>
                  <td>National AI strategy</td>
                  <td>Low</td>
                </tr>
                <tr>
                  <td>🇸🇦 Saudi Arabia</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Government-led</td>
                  <td>Enterprise</td>
                  <td>Digital Authority, CISO</td>
                  <td>Vision 2030, AI adoption</td>
                  <td>Low</td>
                </tr>
                <tr>
                  <td>🇯🇵 Japan</td>
                  <td>⭐⭐⭐⭐ High</td>
                  <td>Enterprise-first</td>
                  <td>Team</td>
                  <td>Security Ops, Risk</td>
                  <td>AI safety, reliability</td>
                  <td>Medium</td>
                </tr>
                <tr>
                  <td>🇮🇳 India</td>
                  <td>⭐⭐⭐ Medium</td>
                  <td>Individual-first</td>
                  <td>Individual / Small Team</td>
                  <td>Developers, Engineers</td>
                  <td>Career growth, certification</td>
                  <td>High</td>
                </tr>
                <tr>
                  <td>🇧🇷 Brazil</td>
                  <td>⭐⭐ Medium-Low</td>
                  <td>Individual-first</td>
                  <td>Individual</td>
                  <td>Security Engineers</td>
                  <td>Skills gap</td>
                  <td>High</td>
                </tr>
                <tr>
                  <td>🇵🇱 Poland</td>
                  <td>⭐⭐⭐ Medium</td>
                  <td>Mixed</td>
                  <td>Individual → Team</td>
                  <td>Security Consultants</td>
                  <td>EU compliance outsourcing</td>
                  <td>Medium</td>
                </tr>
                <tr>
                  <td>🇷🇴 Romania</td>
                  <td>⭐⭐ Medium-Low</td>
                  <td>Individual-first</td>
                  <td>Individual</td>
                  <td>SOC Analysts</td>
                  <td>Career mobility</td>
                  <td>High</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* Expanded EU Breakdown */}
        <section className="market-section">
          <h3>🇪🇺 Expanded EU Breakdown (AI Security Training Focus)</h3>
          <p className="section-intro">
            This section zooms into EU countries with real buying power, separating enterprise-heavy vs individual-heavy markets.
          </p>

          {/* Tier 1 EU */}
          <div className="tier-section">
            <h4>Tier 1 EU: Best for Team & Enterprise Licenses</h4>
            
            <div className="country-card">
              <h5>🇩🇪 Germany</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>Very High</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Enterprise, Industrial</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>Manufacturing, Automotive, Banking</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>EU AI Act, NIS2, operational risk</td>
                  </tr>
                  <tr>
                    <td className="attribute">Sales Notes</td>
                    <td>Formal procurement, strong preference for frameworks</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Team / Enterprise</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="country-card">
              <h5>🇫🇷 France</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>High</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Enterprise & Public Sector</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>Telecoms, Government, Finance</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>Sovereignty, regulation, AI ethics</td>
                  </tr>
                  <tr>
                    <td className="attribute">Sales Notes</td>
                    <td>Trust and credibility matter more than price</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Team</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="country-card">
              <h5>🇳🇱 Netherlands</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>High</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Enterprise, Cloud-native firms</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>SaaS, Finance, Logistics</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>Cloud AI risk, compliance</td>
                  </tr>
                  <tr>
                    <td className="attribute">Sales Notes</td>
                    <td>Faster decisions than DE/FR</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Team</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="country-card">
              <h5>🇸🇪 Sweden</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>High</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Product & AI teams</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>Tech, Automotive, FinTech</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>Responsible AI, innovation safety</td>
                  </tr>
                  <tr>
                    <td className="attribute">Sales Notes</td>
                    <td>Strong interest in ethics + security blend</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Team</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="country-card">
              <h5>🇨🇭 Switzerland (non-EU but critical)</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>Very High</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Banking, Insurance</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>Finance, Healthcare</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>Trust, financial risk</td>
                  </tr>
                  <tr>
                    <td className="attribute">Sales Notes</td>
                    <td>Premium pricing acceptable</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Enterprise</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Tier 2 EU */}
          <div className="tier-section">
            <h4>Tier 2 EU: Mixed (Individual + Team)</h4>
            
            <div className="country-card">
              <h5>🇮🇹 Italy</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>Medium</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Mid-market enterprises</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>Manufacturing, Utilities</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>Compliance pressure</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Small Team</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="country-card">
              <h5>🇪🇸 Spain</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>Medium</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Individuals & SMEs</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>Consulting, IT services</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>Skills gap, EU rules</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Individual → Team</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="country-card">
              <h5>🇵🇱 Poland</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>Medium</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Consultants, Outsourcing firms</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>IT services, SOC providers</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>EU client compliance</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Individual → Team</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Tier 3 EU */}
          <div className="tier-section">
            <h4>Tier 3 EU: Individual-Led Markets</h4>
            
            <div className="country-card">
              <h5>🇷🇴 Romania, 🇧🇬 Bulgaria, 🇭🇺 Hungary</h5>
              <table className="country-table">
                <tbody>
                  <tr>
                    <td className="attribute">Spending Power</td>
                    <td>Medium–Low</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buyer Type</td>
                    <td>Individuals</td>
                  </tr>
                  <tr>
                    <td className="attribute">Industries</td>
                    <td>SOC, MSSPs</td>
                  </tr>
                  <tr>
                    <td className="attribute">Buying Drivers</td>
                    <td>Career progression</td>
                  </tr>
                  <tr>
                    <td className="attribute">License Fit</td>
                    <td>Individual</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* Practical Sales Guidance */}
        <section className="market-section">
          <h3>🎯 Practical Sales Guidance (EU-Specific)</h3>
          
          <div className="guidance-grid">
            <div className="guidance-card">
              <h4>Best EU Countries for Team Licenses</h4>
              <ul>
                <li>🇩🇪 Germany</li>
                <li>🇫🇷 France</li>
                <li>🇳🇱 Netherlands</li>
                <li>🇸🇪 Sweden</li>
                <li>🇬🇧 UK (non-EU but essential)</li>
              </ul>
            </div>

            <div className="guidance-card">
              <h4>Best EU Countries for Individual Subscriptions</h4>
              <ul>
                <li>🇵🇱 Poland</li>
                <li>🇪🇸 Spain</li>
                <li>🇮🇹 Italy</li>
                <li>🇷🇴 Romania</li>
                <li>🇧🇬 Bulgaria</li>
              </ul>
            </div>
          </div>
        </section>

        {/* EU Buyer Psychology */}
        <section className="market-section">
          <h3>🧠 EU Buyer Psychology (Critical)</h3>
          
          <div className="psychology-grid">
            <div className="psychology-card">
              <h4>EU enterprises buy because:</h4>
              <ul>
                <li>"We must be compliant"</li>
                <li>"We need defensible AI governance"</li>
                <li>"Auditors will ask"</li>
              </ul>
            </div>

            <div className="psychology-card">
              <h4>EU individuals buy because:</h4>
              <ul>
                <li>"AI security will be mandatory"</li>
                <li>"This helps me stay employable"</li>
                <li>"Certifications matter"</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default AISecMarkets

